<div class="modal-header">
  <h3 class="modal-title">Fehler</h3>
</div>

<div class="modal-body">
  <i class="fa fa-exclamation-triangle fa-2x red-font" aria-hidden="true"></i>
  @if (!!error) {
    {{ error }}
  }
  @if (!error) {
    Es ist ein unbekannter Fehler aufgetreten, bitte wenden Sie sich an Ihren Administrator
  }
</div>

<div class="modal-footer">
  <button class="btn btn-danger" (click)="close()">Ok</button>
</div>
